import { inkSegments } from "../ink";
import type { Point } from "../domain/types";

export function InkStroke({ points, color, width, opacity = 1, interactive = false }: { points: Point[]; color: string; width: number; opacity?: number; interactive?: boolean }) {
  return <g aria-hidden="true" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" opacity={opacity} pointerEvents={interactive ? undefined : "none"}>
    {inkSegments(points, width).map((segment, index) => <path key={index} d={segment.d} strokeWidth={segment.width} />)}
  </g>;
}
